<script>
import { fandomBasicMixin } from "src/modules/fandom_mixins_module.js";
import { interactionMixin } from "src/modules/interactions_module.js";
import { generateToken } from 'src/modules/recaptcha_v3_module.js'
import { get, range, isNil } from "lodash";

function timeToMidnight() {
  const date = new Date();
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59).toUTCString();
}

function maxCookieName(user) {
  const userId = user.id || "anonymous-user";
  return userId + "-max-limit-reached";
}

export default {
  mixins: [fandomBasicMixin, interactionMixin],
  data: function () {
    return {
      form: {
        success: false,
        errors: [],
        loading: false,
        progress: null,
        data: {},
        maxLimitReached: false
      }
    };
  },
  methods: {
    getYearsSelectValues () {
      const currentYear = (new Date()).getFullYear();
      return range(1900, currentYear);
    },
    getButtonTextFormatted () {
      if (this.form.loading) {
        return this.ft("globals.form.loading");
      } else {
        return this.content.button_text ? this.content.button_text : this.ft("globals.form.send");
      }
    },
    getFieldInputName(fieldName) {
      return `user_upload_interaction[${fieldName}]`;
    },
    getFieldInputId(fieldName) {
      return `field-${fieldName}`;
    },
    getFieldPlaceholder(field) {
      const placeholder = (typeof field.placeholder == "object") ? field.placeholder[globalState.lang] : field.placeholder;
      if (Fandom.exists(placeholder)) {
        return field.required ? `${placeholder} *` : placeholder;
      } else {
        return null;
      }
    },
    getFieldLabel(field) {
      return (typeof field.label == "object") ? field.label[globalState.lang] : field.label;
    },
    onAttachmentChange(event, field) {
      Vue.set(this.form.data, field.name, event.target.files[0]);
    },
    submitSimpleForm(event) {
      if (!this.form.loading) {
        this.form.success = false;
        this.form.loading = true;
        this.form.errors = null;

        let submitForm = (token) => { 
          const data = this.getFormData();
          if (token)
            data.append("recaptcha_enterprise_token", token);

          Fandom.ajax({
              processData: false,
              contentType: false,
              method: "POST",
              url: "/upload_simple_form",
              data: data,
              xhr: () => {
                const xhr = new window.XMLHttpRequest();
                xhr.upload.addEventListener("progress", (evt) => {
                  if (evt.lengthComputable) {
                    this.progress = evt.loaded / evt.total * 100;
                  }
                }, false);
                return xhr;
              },
              success: (data) => {
                this.form.success = data.success;
                if (this.form.success) {
                  if (Fandom.exists(this.content.daily_limit) && data.submissions >= this.content.daily_limit) {
                    const cookieName = maxCookieName(globalState.pageModel.user);
                    Fandom.setCookie(cookieName, true, timeToMidnight());
                    this.maxLimitReached = true;
                  }
                  if (Fandom.exists(this.content.thank_you_page)) {
                    window.location.href = Fandom.applyContextToUrl(this.content.thank_you_page);
                  } else if (!this.content.precompile) {
                    this.resetFormData();      
                  }
                  this.$emit('done', data);
                } else {
                  this.form.errors = data.errors;
                }
              }
            },
            () => {
              this.progress = null;
              this.form.loading = false;
            }
          );
        };
        
        if (globalState.pageModel.aux.recaptcha_enterprise) {
          generateToken(submitForm, "submit");
        } else {
          submitForm();
        }
      }
    },
    mayPrecompileFormData() {
      if (this.content.precompile) {
        Fandom.ajax({
          method: "GET",
          data: {
            interaction_id: this.content.interaction.id,
            container_content_name: this.containerContent.name
          },
          url: "/api/v5/get_submission_init_data",
          success: (data) => {
            Object.keys(data).forEach(key => {
              Vue.set(this.form.data, key, data[key]);
            });
          }
        });
      }
    },
    resetFormData() {
      this.form.data = {};
      this.mayInitializeFields();
    },
    getFormData() {
      const formData = new FormData();
      this.formFields.forEach(field => {
        if (field.type == "birthdate") {
          ["day_of_birth_", "month_of_birth_", "year_of_birth_"].forEach(prefix => {
            const formDataValue = this.form.data[`${prefix}${field.name}`];
            if (formDataValue) {
              formData.append(this.getFieldInputName(`${prefix}${field.name}`), formDataValue);
            }
          });
        } else {
          const formDataValue = this.form.data[field.name];
          if (!isNil(formDataValue) && field.type != "textseparator") {
            formData.append(this.getFieldInputName(field.name), formDataValue);
          }
        }
      });
      formData.append("interaction_id", this.content.interaction.id);
      formData.append("content_id", this.containerContent.id);

      return formData;
    },
    mayInitializeFields() {
      this.formFields.forEach((field) => {
        if (field.type == "hidden") {
          Vue.set(this.form.data, field.name, field.value);
        } else if (field.type == "dropdown") {
          // The dropdown input must be initialized to empty string to display the placeholder
          Vue.set(this.form.data, field.name, "");
        } else if (field.type == "birthdate") {
          // The dropdown input must be initialized to empty string to display the placeholder
          ["day_of_birth_", "month_of_birth_", "year_of_birth_"].forEach(prefix => {
            Vue.set(this.form.data, `${prefix}${field.name}`, "");
          });
        }
      });
    },
    toggleTopic(field, topic) {
      const index = get(this, ['form','data',field.name], []).findIndex(t => t ==topic)
      if (index > -1) {
        // remove only if there is at least another element in the array
        if (get(this, ['form','data',field.name], []).length > 1)
          this.form.data[field.name].splice(index, 1)
      } else {
        this.form.data[field.name].push(topic);
      }
    }
  },
  created() {
    const cookieName = maxCookieName(globalState.pageModel.user);
    this.maxLimitReached = Fandom.readCookie(cookieName) !== null;
  },
  mounted() {
    this.mayInitializeFields();
    this.mayPrecompileFormData();
    // initialize topics field AFTER precompile data
    this.formFields.filter(field => field.type == "topics").forEach((field) => {
      Vue.set(this.form.data, field.name, []);
      Fandom.ajax({
        method: "GET",
        url: `/api/v5/evaluation_tool/weak_topics?content_cache_name=${field.content_cache_name}`,
        success: (data) => {
          Vue.set(this.form.data, field.name, data.topics);
        }
      });
    });
  },
  computed: {
    formFields() {
      return JSON.parse(this.content.form_fields).fields;
    },
    isFormLoading() {
      return this.form.loading || (Fandom.exists(this.form.progress) && parseInt(this.form.progress) < 100);
    }
  }
};
</script>

<template>
  <div generic-form-component>
    <form v-if="!maxLimitReached" @submit.prevent="submitSimpleForm($event)" :action="'/upload_simple_form'" method="post" enctype="multipart/form-data">
      <div v-for="(field, index) in formFields" :key="index">
        <div v-if="field.type == 'dropdown'" class="form-group">
          <label v-if="getFieldLabel(field)">{{getFieldLabel(field)}} <span v-if="field.required">*</span></label>
          <select class="custom-select" :required="field.required" v-model="form.data[field.name]">
            <option value="" disabled selected>{{getFieldPlaceholder(field)}}</option>
            <option v-for="(option, optionIndex) in field.options" :key="`option-${optionIndex}`" :value="option.value">{{option.label}}</option>
          </select>
        </div>
        <div v-else-if="field.type == 'textfield' || field.type == 'piva'" class="form-group">
          <label v-if="getFieldLabel(field)">{{getFieldLabel(field)}} <span v-if="field.required">*</span></label>
          <input v-model="form.data[field.name]" :placeholder="getFieldPlaceholder(field)" class="form-control" type="text" :required="field.required">
        </div>
        <div v-else-if="field.type == 'phone'" class="form-group">
          <label v-if="getFieldLabel(field)">{{getFieldLabel(field)}} <span v-if="field.required">*</span></label>
          <input v-model="form.data[field.name]" :placeholder="getFieldPlaceholder(field)" class="form-control" type="number" :required="field.required">
        </div>
        <div v-else-if="field.type == 'textarea'" class="form-group">
          <label v-if="getFieldLabel(field)">{{getFieldLabel(field)}} <span v-if="field.required">*</span></label>
          <textarea v-model="form.data[field.name]" :placeholder="getFieldPlaceholder(field)" class="form-control" rows="5" :maxlength="field.maxlength || 1000"></textarea>
        </div>
        <div v-else-if="field.type == 'radio'" class="form-group">
          <label v-if="getFieldLabel(field)">{{getFieldLabel(field)}} <span v-if="field.required">*</span></label>
          <div class="d-flex">
            <div v-for="(option, optionIndex) in field.options" :key="`option-${optionIndex}`" class="d-flex align-items-center mr-3">
              <input type="radio" :value="option.value" v-model="form.data[field.name]" class="mr-2">{{option.label}}</input>
            </div>
          </div>
        </div>
        <div v-else-if="field.type == 'checkbox'" class="form-group form-check">
          <input type="checkbox" class="form-check-input" v-model="form.data[field.name]">
          <label class="form-check-label">{{getFieldLabel(field)}} <span v-if="field.required">*</span></label>
        </div>
        <div v-else-if="field.type == 'attachment'" class="form-group">
          <label v-if="getFieldLabel(field)" class="form-label">{{getFieldLabel(field)}} <span v-if="field.required">*</span></label>
          <div class="custom-file">
            <input type="file" class="custom-file-input" @change="onAttachmentChange($event, field)">
            <label class="custom-file-label">{{getFieldPlaceholder(field)}}</label>
            <small class="form-text text-muted" v-if="form.data[field.name] && form.data[field.name].name">{{form.data[field.name].name}}</small>
          </div>
        </div>
        <div v-else-if="field.type == 'topics'" class="form-group">
          <label v-if="getFieldLabel(field)" class="form-label">{{getFieldLabel(field)}} <span v-if="field.required">*</span></label>
          <div class="row">
            <div class="col-12 col-md-6" v-for="(topic, index) in field.topics" :key="`topic-${index}`">
              <button
                class="btn w-100 my-2"
                @click.stop.prevent="toggleTopic(field, topic)"
                :class="form.data[field.name] instanceof Array && form.data[field.name].includes(topic) ? 'btn-dark' : 'btn-outline-dark'"
              >
                {{topic}}
              </button>
            </div>
          </div>
        </div>
        <div v-else-if="field.type == 'email'" class="form-group">
          <label v-if="getFieldLabel(field)">{{getFieldLabel(field)}} <span v-if="field.required">*</span></label>
          <input v-model="form.data[field.name]" :placeholder="getFieldPlaceholder(field)" class="form-control" type="email" :required="field.required">
        </div>
        <div v-else-if="field.type == 'birthdate'" class="form-group">
          <label v-if="getFieldLabel(field)">{{getFieldLabel(field)}} <span v-if="field.required">*</span></label>
          <div class="row">
            <div class="col-12 col-sm-4">
              <select class="custom-select" v-model="form.data[`day_of_birth_${field.name}`]" :required="field.required">
                <option value="" disabled selected>{{ft("globals.form.day")}}</option>
                <option v-for="day in 31" :value="day" :key="`day-${day}`">{{day}}</option>
              </select>
            </div>
            <div class="col-12 col-sm-4">
              <select class="custom-select" v-model="form.data[`month_of_birth_${field.name}`]" :required="field.required">
                <option value="" disabled selected>{{ft("globals.form.month")}}</option>
                <option v-for="month in 12" :value="month" :key="`month-${month}`">{{month}}</option>
              </select>
            </div>
            <div class="col-12 col-sm-4">
              <select class="custom-select" v-model="form.data[`year_of_birth_${field.name}`]" :required="field.required">
                <option value="" disabled selected>{{ft("globals.form.year")}}</option>
                <option v-for="year in getYearsSelectValues()" :value="year" :key="`year-${year}`">{{year}}</option>
              </select>
            </div>
          </div>
        </div>

        <p v-if="field.type == 'textseparator'">{{getFieldLabel(field)}}</p>
      </div>

      <button type="submit" class="btn col-sm-3" :class="getPrimaryButtonClass(content.button_class)">{{getButtonTextFormatted()}}</button>
      <small class="form-text text-muted mt-2">{{ft("globals.form.required_fields")}}</small>

      <div class="progress" v-if="form.progress">
        <div class="progress-bar" role="progressbar" :aria-valuenow="form.progress" aria-valuemin="0" aria-valuemax="100" :style="{ width: form.progress + '%' }">
          <span class="progress-bar-text">{{ft("globals.form.uploading", {percentage: form.progress})}}</span>
        </div>
      </div>

      <form-feedback :errors="form.errors" :success="form.success" class="mt-3" :success-message="ft('globals.form.success')"></form-feedback>
    </form>
    <div v-else>
      <span>{{ft("globals.form.max_limit_reached")}}</span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.progress-bar-text {
  position: absolute;
  left: 0;
  right: 0;
}

.btn-outline-dark:hover {
  background-color: #e0e0e0;
  color: $dark;
}

@include media-breakpoint-down(sm) {
  .custom-file-label,
  .custom-file-input {
    height: 200%;
    overflow: hidden;
  }

  .custom-file-label {
    padding-top: 0.2rem;
    padding-left: 0.2rem;
  }

  .custom-file-label::after {
    bottom: 0;
    top: auto;
    width: 100%;
    justify-content: center;
    display: flex;
  }
}
</style>
